import { requestData } from "../../api-config";

import { TipCreate, TipDetail, TipUpdate } from "@/types/tip";

export const createTip = async (
  tipData: TipCreate,
): Promise<TipDetail | null> => {
  return await requestData<TipDetail>("billing/tips/create", "post", {
    json: tipData,
  });
};

export const getTip = async (tipId: string): Promise<TipDetail | null> => {
  return await requestData<TipDetail>(`billing/tips/${tipId}`);
};

export const updateTip = async (
  tipId: string,
  tipUpdate: TipUpdate,
): Promise<TipDetail | null> => {
  return await requestData<TipDetail>(`billing/tips/${tipId}`, "put", {
    json: tipUpdate,
  });
};

export const deleteTip = async (tipId: string): Promise<boolean | null> => {
  return await requestData<boolean>(`billing/tips/${tipId}`, "delete");
};
